import { LabelledSwitch } from '@/components/form/LabelledSwitch';
import { useBbbMode, useRegionFilter } from '@/services/preferences/useLocalPreferences';
import { FunctionComponent } from 'react';
import { CatalogueExplorerFilterProvider } from '../../../../services/catalogue/CatalogueExplorerFilterService';
import CatalogueExplorerFilter from './CatalogueExplorerFilter';
import { CatalogueExplorerFilterCallback } from './CatalogueExplorerFilterModal';
import { useCatalogueService } from '@/services/catalogue/useCatalogueService';
import { RoleType } from '@/services/authentication/hooks/user';
import { useRegions } from '@/services/api/hooks/region';
import { Property, SelectInput } from '@/components/form/fields/select/SelectInput';

interface CatalogueExplorerFilterContainerProps {
  categoryId?: string;
  onFilterCallback: (props: CatalogueExplorerFilterCallback) => void;
  customContent?: JSX.Element;
}

const CatalogueExplorerFilterContainer: FunctionComponent<CatalogueExplorerFilterContainerProps> = ({
  categoryId,
  onFilterCallback,
  customContent
}) => {
  const { bbbMode, setBbbMode } = useBbbMode();

  const configuration = useCatalogueService(c => c.configuration);
  const isAdmin = configuration.for === RoleType.Admin;

  const [regions] = useRegions();
  const regionOptions: Property[] = [
    { id: '', name: 'All Regions' },
    ...regions.map(r => ({ id: r.id, name: r.name }))
  ];

  const { regionId, setRegionId } = useRegionFilter();

  return (
    <CatalogueExplorerFilterProvider>
      <div className="flex justify-between w-full items-start">
        <CatalogueExplorerFilter categoryId={categoryId} onFilterCallback={onFilterCallback} />
        <div className="flex gap-5">
          {customContent}
          {isAdmin && (
            <SelectInput
              className="w-48"
              options={regionOptions}
              id={'regionSelect'}
              value={regionOptions.find(r => r.id === regionId) || null}
              onChange={value => {
                setRegionId(value?.id || '');
              }}
            />
          )}
          <LabelledSwitch
            onChange={setBbbMode}
            value={bbbMode}
            offLabel="Full Catalogue"
            onLabel="Basic - Better - Best"
          />
        </div>
      </div>
    </CatalogueExplorerFilterProvider>
  );
};

export default CatalogueExplorerFilterContainer;
